import { GET_ALL_COURSE, GET_ALL_GIFT } from '../actions/types'

const initialState = {
  courseList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 0,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  gift_list: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 0,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  loading: true,
}

export default function setting(state = initialState, actions) {
  const { type, payload } = actions
  switch (type) {
    case GET_ALL_COURSE:
      return {
        ...state,
        courseList: payload,
        loading: false,
      }
    case GET_ALL_GIFT:
      return {
        ...state,
        gift_list: payload,
        loading: false,
      }
    default:
      return state
  }
}
